import { MailSendingAccountsAndSignaturesAndDraftsAndTemplates } from 'src/models/mail';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheMailAccountsAndSignaturesForTheAuthenticatedUserCallback extends Callback<MailSendingAccountsAndSignaturesAndDraftsAndTemplates> {
	public constructor(
		private readonly setMailAccountsAndSignaturesAndDraftsAndTemplates: (
			payload: MailSendingAccountsAndSignaturesAndDraftsAndTemplates | null
		) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: MailSendingAccountsAndSignaturesAndDraftsAndTemplates): void => {
		this.setMailAccountsAndSignaturesAndDraftsAndTemplates(successResponse);
	};
}
